import { AddTagRequest, listTagsResponseSchema, ListTagsResponse, TAGS_PATH } from '@quizdb/common';
import { quizdbApi } from '../api/quizdbApi';

/** The tag list's endpoints (QZ-D40). */
export const tagApi = quizdbApi.injectEndpoints({
  endpoints: (builder) => ({
    listTags: builder.query<ListTagsResponse, void>({
      query: () => TAGS_PATH,
      transformResponse: (response: unknown) => listTagsResponseSchema.parse(response),
      providesTags: ['TagList'],
    }),
    addTag: builder.mutation<void, AddTagRequest>({
      query: (body) => ({ url: TAGS_PATH, method: 'POST', body }),
      invalidatesTags: ['TagList'],
    }),
  }),
});

export const { useListTagsQuery, useAddTagMutation } = tagApi;
